
<div class="my-auto badge border text-light badge-info">{{country}}</div>
